export default __webpack_public_path__ + "static/media/polk_logo_and_fantasy_white.b10d16a6.png";